export const get_message = `query get_message($id: Int!){
    get_message(id: $id){
        id
        time
        type
        subject
        subject_en
        text
        text_en
        awaiting_acception
        accepted
        unread
        attachments
    }
}`;
